// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_user_files_s3_bucket: process.env.REACT_APP_S3_BUCKET,
  aws_user_files_s3_bucket_region: process.env.REACT_APP_S3_BUCKET_REGION
};

export default awsmobile;
